import React from "react";
import { Link } from "react-router-dom";
import { ImFacebook2 } from "react-icons/im";
import {
  FaInstagram,
  FaLinkedin,
  FaHome,
  FaPhoneAlt,
  FaCopyright,
} from "react-icons/fa";
import { CgMail } from "react-icons/cg";

const Footer = () => {
  return (
    <>
   
      <footer className="bg-warning text-dark pt-5 pb-4">
        <div className="container text-center text-md-left">
          <div className="row text-center text-md-left">
            <div className="col-md-3 col-lg-3 col-xl-3 mx-auto mt-3">
              <Link to="/" className="navbar-brand">
                <img
                  src="/assets/logo.jpg"
                  alt="Logo"
                  className="imgStyle"
                />
              </Link>
              <p>
              Music is a pleasant sound which is a combination of melodies and harmony and which soothes you. 
              </p>
            </div>
            <div className="col-md-2 col-xl-2 mx-auto mt-3">
              <h5 className="text-uppercase mb-4 font-weight-bold text-warning">
                Heading
              </h5>
              <p>
                <Link to="/" className="text-white  ">
                 <b><i>Home</i> </b>
                </Link>
              </p>
              <p>
                <Link to="/about" className="text-white ">
                  About
                </Link>
              </p>
              <p>
                <Link to="/services" className="text-white ">
                  Services
                </Link>
              </p>
              <p>
                <Link to="/blog" className="text-white ">
                  Blog
                </Link>
              </p>
              <p>
                <Link to="/contact" className="text-white ">
                  Contact
                </Link>
              </p>
            </div>
            <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mt-3">
              <h5 className="text-uppercase mb-4 font-weight-bold text-warning">
                Links
              </h5>
              <p>
                <Link to="/" className="text-white ">
                  <ImFacebook2 /> <span className="ml-2">Facebook Page</span>
                </Link>
              </p>
              <p>
                <Link to="/" className="text-white ">
                  <FaInstagram />
                  <span className="ml-2">Instagram Profile</span>
                </Link>
              </p>
              <p>
                <Link to="/" className="text-white ">
                  <FaLinkedin /> <span className="ml-2">LinkedIn Profile</span>
                </Link>
              </p>
            </div>
            <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
              <h5 className="text-uppercase mb-4 font-weight-bold text-warning">
                Contact
              </h5>
              <p>
                <FaHome /> <span className="ml-2">Kolkata, West Bengal</span>
              </p>
              <p>
                <CgMail /> <span className="ml-2">abc@gmail.com</span>
              </p>
              <p>
                <FaPhoneAlt /> <span className="ml-2">+91 0000000000</span>
              </p>
            </div>
          </div>
          <hr className="mb-4" />
          <div className="row align-items-center ">
            <div className="col-md-7 col-lg-8">
              <p>
                Copyright <FaCopyright /> 2024 All rights reserved by :{" "}
                <Link to="/" className="text-white ">
                  <strong className="text-warning">Company Name</strong>
                </Link>
              </p>
            </div>
          </div>
        </div>
      </footer>
      
    </>
  );
};

export default Footer;
